import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 15"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m8.602 1.215 1.394 4.348h4.348a.64.64 0 0 1 .601.464c.11.246 0 .547-.218.711l-3.582 2.79 1.394 4.374c.11.274 0 .575-.246.739a.62.62 0 0 1-.766-.028L8 11.88l-3.555 2.734a.62.62 0 0 1-.765.028c-.246-.164-.356-.465-.246-.739l1.394-4.375-3.582-2.789c-.219-.164-.3-.465-.219-.71a.65.65 0 0 1 .63-.465h4.32L7.37 1.215A.65.65 0 0 1 8 .75a.64.64 0 0 1 .602.465"
    }, null, -1)
  ]))]))
}
export default { render: render }